module.exports = __webpack_public_path__ + "img/pagination-mobile-5items.7341a693.png";